import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tyc-page',
  templateUrl: './tyc-page.component.html',
  styleUrls: ['./tyc-page.component.scss']
})
export class TycPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.gotoTop();
  }
  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
}
